"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
exports.location = prop_types_1.default.shape({
    hash: prop_types_1.default.string.isRequired,
    key: prop_types_1.default.string,
    pathname: prop_types_1.default.string.isRequired,
    search: prop_types_1.default.string.isRequired,
    state: prop_types_1.default.oneOfType([
        prop_types_1.default.array,
        prop_types_1.default.bool,
        prop_types_1.default.number,
        prop_types_1.default.object,
        prop_types_1.default.string,
    ]),
});
exports.history = prop_types_1.default.shape({
    action: prop_types_1.default.oneOf(['PUSH', 'REPLACE', 'POP']).isRequired,
    block: prop_types_1.default.func.isRequired,
    canGo: prop_types_1.default.func,
    createHref: prop_types_1.default.func.isRequired,
    entries: prop_types_1.default.arrayOf(exports.location),
    go: prop_types_1.default.func.isRequired,
    goBack: prop_types_1.default.func.isRequired,
    goForward: prop_types_1.default.func.isRequired,
    index: prop_types_1.default.number,
    length: prop_types_1.default.number,
    listen: prop_types_1.default.func.isRequired,
    location: exports.location.isRequired,
    push: prop_types_1.default.func.isRequired,
    replace: prop_types_1.default.func.isRequired,
});
exports.match = prop_types_1.default.shape({
    isExact: prop_types_1.default.bool,
    params: prop_types_1.default.object.isRequired,
    path: prop_types_1.default.string.isRequired,
    url: prop_types_1.default.string.isRequired,
});
var routeShape = {
    path: prop_types_1.default.string,
    exact: prop_types_1.default.bool,
    strict: prop_types_1.default.bool,
    sensitive: prop_types_1.default.bool,
    component: prop_types_1.default.func,
};
routeShape.routes = prop_types_1.default.arrayOf(prop_types_1.default.shape(routeShape));
exports.route = prop_types_1.default.shape(routeShape);
exports.default = {
    location: exports.location,
    history: exports.history,
    match: exports.match,
    route: exports.route,
};



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/react-router-prop-types/dist/index.js
// module id = 2577
// module chunks = 1